import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";
import { BankAccountInterface } from "../../Entity/Entities/BankAccount/BankAccountInterface";
import Translator from "../../Translation/Translator";

export default function* chargeTypeCreate(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_CHARGE_TYPE_CREATE_CLEAR,
    });

    yield put({
      type: Constants.GLOBAL_CHARGE_TYPE_CREATE_REQUEST
    });

    const res = yield call(Http.post, `charge-type`, {
      ...action.payload?.chargeType
    });

    const chargeType: BankAccountInterface = res.data.data;

    yield put({
      type: Constants.GLOBAL_RECEIVE_DATA_TYPES_LIST
    });

    yield put({
      type: Constants.GLOBAL_CHARGE_TYPE_CREATE_SUCCESS
    });

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-message-charge-type-created-successfully"),
        type: "success"
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, chargeType);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_CHARGE_TYPE_CREATE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchChargeTypeCreate() {
  yield takeEvery(Constants.GLOBAL_CHARGE_TYPE_CREATE_START, chargeTypeCreate);
}
